<template>
  <v-app id="app">
    <v-main>
      <router-view />

      <v-dialog v-model="updateExists" persistent max-width="420">
        <v-card>
          <v-card-title class="headline">
            <v-icon left color="primary">mdi-update</v-icon>
            System Update Available
          </v-card-title>
          <v-card-text>
            A new version of the application is available. Please refresh to get the latest features and fixes.
            <div class="caption grey--text mt-2">Current: v{{ currentVersion }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="snoozeUpdate">Update Later</v-btn>
            <v-btn color="primary" @click="refreshApp">Update Now</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="updateSuccessSnackbar"
        :timeout="6000"
        color="success"
        top
        right
      >
        Successfully updated to v{{ currentVersion }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="updateSuccessSnackbar = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
import swUpdate from '@/mixins/swUpdate'

export default {
  mixins: [swUpdate],
  mounted() {
    if (this.USERACCOUNT_LOAD.length != 0) {
      this.$store.dispatch("credentials");
    }
  },
  watch: {
    USERACCOUNT_LOAD(val) {
      if (val.length != 0) {
        this.$store.dispatch("credentials");
      }
    },
  },
  computed: {
    ...mapGetters([
      "USERACCOUNT_LOAD",
      "LINK_ACTIVE",
    ]),
  },
};
</script>
